<template>
    <div>
        <div class="cvlibPacksOrder">
            <div class="cvlibPackOrder" v-for="(cvlibPack, index) in cvlibPacks">

                <input type="hidden" :name="'cvlibPacks[' + index + '][id]'" v-model="cvlibPack.id">

                <div class="row">
                    <div class="col-md-5">
                        <div class="form-group" aria-required="true">
                            <label :for="'cvlibPacks[' + index + '][name]'">
                                <slot name="name-label"></slot>
                            </label>
                            <input type="text" :name="'cvlibPacks[' + index + '][name]'" v-model="cvlibPack.name"  @keydown.enter.prevent required="required">
                        </div>
                    </div>

                    <div class="col-md-5">
                        <div class="form-group" aria-required="true">
                            <label :for="'cvlibPacks[' + index + '][color]'">
                                <slot name="color-label"></slot>
                            </label>
                            <input type="color" :name="'cvlibPacks[' + index + '][color]'" v-model="cvlibPack.color"  @keydown.enter.prevent required="required">
                        </div>
                    </div>

                    <div class="col-md-12">
                        <div class="form-group" aria-required="true">
                            <label :for="'cvlibPacks[' + index + '][study_sections][]'">
                                <slot name="study_sections-label"></slot>
                            </label>

                            <search-select
                                    :ref="'cvlibPacks_' + index + '_study_sections'"
                                    required="required"
                                    :multiple='true'
                                    :selecteddata="cvlibPack.study_section_values"
                                    :placeholder="domainplaceholder"
                                    :options="domains"
                                    :inputname="'cvlibPacks[' + index + '][study_sections][]'">
                            </search-select>
                        </div>
                    </div>

                    <div class="col-md-2 cvlibPackOrder__actions">
                        <button type="button" class="btn-medium-grey cvlibPackOrder__delete" @click="deleteCvlibPack(index)">
                            <slot name="delete-label"></slot>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="mt-5">
            <button type="button" class="btn-blue" @click="addCvlibPack">
                <slot name="add-label"></slot>
            </button>
        </div>
    </div>
</template>

<script>
    import searchSelect from '../../components/forms/searchSelect';

    export default {
        components: { searchSelect },
        props: {
            domains: Array,
            domainplaceholder: String,
            oldcvlibpacks: {
                id: Number,
                name: String,
                color: String,
                study_sections: Array,
                study_section_values: Array,
                default: () => [
                    {
                        id: -1,
                        name: '',
                        color: '#000000',
                        study_sections: [],
                        study_section_values: [],
                    }
                ]
            }
        },
        data() {
            return {
                cvlibPacks: this.oldcvlibpacks
            }
        },
        methods: {
            addCvlibPack() {
                this.cvlibPacks.push({
                    id: -1,
                    name: '',
                    color: '#000000',
                    study_sections: [],
                    study_section_values: [],
                });
            },
            deleteCvlibPack(index) {

                this.cvlibPacks.forEach((item, itemIndex) => {
                    if (itemIndex >= index && (itemIndex + 1 < this.cvlibPacks.length)) {
                        this.$children[itemIndex].value = this.$children[itemIndex + 1].value;
                    }
                    else if (itemIndex + 1 === this.cvlibPacks.length) {
                        this.$children[itemIndex].value = [];
                    }
                });

                this.cvlibPacks.splice(index, 1);
                /*
                if (this.cvlibPacks.length === 0) {
                    this.addCvlibPack();
                }*/
            }
        }
    }
</script>
